/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FoodNutrientType = 'Energy' | 'Protein' | 'Carbohydrate' | 'Fat' | 'Sugars' | 'Sodium' | 'TransFat' | 'SaturatedFat' | 'Cholesterol' | 'DietaryFiber';

export const FoodNutrientType = {
    Energy: 'Energy' as FoodNutrientType,
    Protein: 'Protein' as FoodNutrientType,
    Carbohydrate: 'Carbohydrate' as FoodNutrientType,
    Fat: 'Fat' as FoodNutrientType,
    Sugars: 'Sugars' as FoodNutrientType,
    Sodium: 'Sodium' as FoodNutrientType,
    TransFat: 'TransFat' as FoodNutrientType,
    SaturatedFat: 'SaturatedFat' as FoodNutrientType,
    Cholesterol: 'Cholesterol' as FoodNutrientType,
    DietaryFiber: 'DietaryFiber' as FoodNutrientType
};

